export const environment = {
    production: true,
    admNome: 'ADD BENEFÍCIOS',
    apiUrl: 'https://api.g2saude.com.br/api/cliente',
    assets: 'agrega',
    base: 'agrega'
};
